// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g-radio{display:flex;flex-wrap:wrap;margin-top:-10px}.g-radio li{cursor:pointer;padding:4px 14px;border-radius:4px;background:#f7f8f9;color:#999;font-size:14px;line-height:20px;margin-right:10px;margin-top:10px;transition:all .3s}.g-radio li.is-active{background:#e1eafd;color:#386ff2;font-weight:500}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
